import ErrorBoundary from './ErrorBoundary/ErrorBoundary';

export default ErrorBoundary;
